/**
 * English translations for membership-related messages
 */
const membership = {
  membershipPaused: {
    title: "Membership Paused",
    subtitle: "Your account access has been temporarily paused",
    message: "Your membership has been paused. Please contact our support team for further instructions and assistance.",
    instruction: "Our support team will help you understand the reason and guide you through the next steps.",
    supportTeam: "Support Team",
    contactButton: "Contact Support on WhatsApp",
    responseTime: "Our team typically responds within 24 hours",
    signOutPrompt: "Need to switch accounts?",
    signOutButton: "Sign Out",
  },
};

export default membership;
